import axios from "axios";

export const API = `${window.location.origin}/api`;

// All requests carry the httpOnly `access_token` cookie via withCredentials.
// We deliberately do NOT read tokens from localStorage — that would re-introduce
// the XSS vulnerability the cookie migration was meant to close.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(d);
}

export default api;
